export const codeBlockRootSx = {
  bgcolor: 'background.default',
  borderRadius: 'var(--app-radius-md)',
  my: '8px',
  border: 'none',
  position: 'relative',
  '&:hover .copy-btn': { opacity: 1 },
}

export const codeBlockPreSx = {
  margin: 0,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  fontSize: 'var(--app-font-size-sm)',
  lineHeight: 1.45,
  color: 'text.primary',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}
